import React, { FC } from 'react'
import { FieldNames } from 'Constants/FieldNames'
import { Form, Input } from 'antd'
import { GetFieldDecoratorOptions, WrappedFormUtils } from 'antd/lib/form/Form'

interface UploadFormConnectorProps {
	form?: WrappedFormUtils
	fieldOptions?: GetFieldDecoratorOptions
	fieldName?: FieldNames
}

export const UploadFormConnector: FC<UploadFormConnectorProps> = ({
	form,
	fieldOptions,
	fieldName,
	children,
}) => {
	return (
		<>
			{form ? (
				<div className="ppneo-common__input--hidden">
					<Form.Item>
						{form.getFieldDecorator<FieldNames>(
							fieldName as keyof FieldNames,
							fieldOptions
						)(<Input />)}
						<>{children}</>
					</Form.Item>
				</div>
			) : (
				<>{children}</>
			)}
		</>
	)
}
